module.exports = __webpack_public_path__ + "static/media/w-logo.21663502.png";